import store from "datastore/store";
import fetchCollection from "./fetchCollection";

export default async function observeSubscriptions() {
  store.dispatch({ type: "ADD_SUBSCRIPTIONS_LOADING" });
  const subscriptions = await fetchCollection("subscriptions");
  if (subscriptions) {
    store.dispatch({ type: "ADD_SUBSCRIPTIONS_SUCCESS", subscriptions });
  } else {
    store.dispatch({ type: "ADD_SUBSCRIPTIONS_ERROR" });
  }
}
